export const UpdateTicketState = (data, stage, stageName) => {
  data.ticketStatus.id = stage;
  data.ticketStatus.status = stageName;
  data.ticketStatus.description = stageName;
  return data;
};

export function countObjectsByBuildingId(objects, alarmType) {
  const countByBuildingId = {};

  for (const obj of objects) {
    if (obj.impactType === alarmType && obj.ticketStatus < 4) {
      const buildingId = obj.buildingIdAssociated;
      if (countByBuildingId.hasOwnProperty(buildingId)) {
        countByBuildingId[buildingId]++;
      } else {
        countByBuildingId[buildingId] = 1;
      }
    }
  }
  return countByBuildingId;
}

export function transformObjectToArray(obj) {
  return Object.entries(obj).map(([buildingId, alarms]) => ({
    buildingId: parseInt(buildingId),
    alarms: alarms,
  }));
}
//transform to key value as you did nodered

export function extractTicketInfo(inputString) {
  const regex = /Ticket with ID: (\d+) passed to status: (\w+)/;
  const match = inputString.match(regex);

  if (match) {
    const idx = match[1];
    const statusx = match[2];

    return [idx, statusx];
  } else {
    return null;
  }
}


export function isNewTicketCreated(inputString) {
  if(inputString === "A new Ticket has been created"){
    return true
  }
  else{
    return false
  }
}



{
  /**Conversion of image to bytes */
}
export const convertImageToBytes = (imageFile) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const bytes = new Uint8Array(reader.result);
      resolve(bytes);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsArrayBuffer(imageFile);
  });
};
{
  /**Conversion of image to bytes */
}
export const bytesToString = (bytes) => {
  // Convert Uint8Array to regular array
  const byteArray = Array.from(bytes);
  // Convert regular array to string using JSON.stringify
  const byteString = JSON.stringify(byteArray);
  return byteString;
};

export const convertToBase64 = (selectedFile, callBackFunc,filetype) => {
  const reader = new FileReader();

  reader.readAsDataURL(selectedFile);

  reader.onload = () => {
    callBackFunc(reader.result,filetype);
  };
};

export const base64Suffix = "data:image/png;base64,";


export function restructureJsonForAlisDialog(arrayofFields,jsonData){
var formattedJsonData={}
for(var i =0; i<arrayofFields.length;i++){
  formattedJsonData[arrayofFields[i]]=jsonData[arrayofFields[i]]
  //console.log(i,arrayofFields[i],jsonData[arrayofFields[i]])
}
return formattedJsonData
}
{/*function that returns if it finds an item with an alarm */}
export function isAssetAlarmed(assetItems) { 

    var isAlarm = false;
    var itemWithAlarm=null
     if(assetItems){
     assetItems.forEach(function(item) {
          if (item.hasOwnProperty('alarm') && item.alarm === true) {
            isAlarm = true;
            itemWithAlarm=item.serialNumber
            return [isAlarm,itemWithAlarm]
          }

    });
  }

  return [isAlarm,itemWithAlarm];
}

export function checkSiteAlarms(allSites) {
  var result = [];

  allSites.forEach(function (site) {
    var isAlarm = false;
    var item_ = null;
    site.buildings.forEach(function (building) {
      building.assets.forEach(function (asset) {
        asset.items.forEach(function (item) {
          if (item.hasOwnProperty("alarm") && item.alarm === true) {
            isAlarm = true;
            item_ = item;
          }
        });
      });
    });

    var siteObject = {
      siteId: site.id,
      isAlarm: isAlarm,
      item: item_,
    };

    result.push(siteObject);
  });

  return result;
}

export const determineSitesWithAlarms=(sites,itemsWithAlarms)=>{
  const sites__ = [];
  sites.forEach(function (element) {
    var obj = {
      id: element.id,
      name: element.name,
      description: element.name,
      position: [
        parseFloat(element.latitude),
        parseFloat(element.longitude),
      ],
      alarm: null,
      alarmItem: null,
    };
    var matchingAlarm = itemsWithAlarms.find(function (alarm) {
      return alarm.siteId === parseInt(obj.id); // return Matching alarm (siteId with obj.id)
    });

    if (matchingAlarm) {
      console.log("matching al : ", matchingAlarm);
      obj.alarm = matchingAlarm.isAlarm; // Set alarm property if matchingAlarm exists
      obj.alarmItem = matchingAlarm.item;
    }
    console.log(element);
    sites__.push(obj);
    
  });
  return sites__
 }

export function checkBuildingAlarms(buildings) {
  //function check if there are any items in the site with alarms
  var result = [];

  buildings.forEach(function (building) {
    var isAlarm = false;
    var item_ = null;
    if (building.assets && building.assets.length > 0) {
      building.assets.forEach(function (asset) {
        asset.items.forEach(function (item) {
          if (item.hasOwnProperty("alarm") && item.alarm === true) {
            isAlarm = true;
            item_ = item;
          }
        });
      });
    }

    var buildingObject = {
      buildingId: building.id,
      isAlarm: isAlarm,
      item: item_,
    };

    result.push(buildingObject);
  });

  return result;
}

 export const determineBuildingsWithAlarms=(site,buildingsWithAlarms)=>{
  const sites_ = [];
  var i=0;
  site.buildings.forEach(function (element) {
    i=i+1;
    var deltaLong=0.0000545+i/10000
    var deltaLat=-0.00007645+i/10000
    var obj = {
      id: element.id,
      name: element.name,
      description: element.name,
      position: [
        parseFloat(site.latitude) + deltaLat,
        parseFloat(site.longitude) + deltaLong
      ],
      alarm: null,
      alarmItem: null,
    };
    var matchingAlarm = buildingsWithAlarms.find(function (alarm) {
      return alarm.buildingId === parseInt(obj.id); // return Matching alarm (siteId with obj.id)
    });

    if (matchingAlarm) {
      console.log("matching al : ", matchingAlarm);
      obj.alarm = matchingAlarm.isAlarm; // Set alarm property if matchingAlarm exists
      obj.alarmItem = matchingAlarm.item;
    }
    console.log(element);
    sites_.push(obj);
    console.log(sites_);
  });
  return sites_;
 }